<script setup>
import { ref, onMounted, computed, watch } from "vue";
import useChatWidget from "../stores/chatWidget";
import { Button } from "../../components";
import Calendar from "../components/Calendar.vue";

const $chatWidget = useChatWidget();
const $globalSetting = computed(() => $chatWidget.getGlobalSettings());
const $config = $chatWidget.getConfig;
const $setting = $chatWidget.getSettings;
const $payload = $chatWidget.getPayload();
const $availableDates = computed(() => $chatWidget.getAvailableDates());
const showCal = ref(false);
const selectedDate = ref(null);

onMounted(async () => {
  if ($availableDates.value.length === 0) {
    await $chatWidget.fetchAvailableDates();
  }
});

watch($availableDates, (newDates) => {}, { immediate: true });

const generateDateSlots = () => {
  const slots = [];

  for (let i = 0; i < 2; i++) {
    const date = new Date();
    date.setDate(date.getDate() + i);
    const fullDate = date;

    let prefix = "";

    switch (i) {
      case 0:
        prefix = "Today, ";
        break;
      case 1:
        prefix = "Tomorrow, ";
        break;
      default:
        break;
    }

    slots.push({
      id: i + 1,
      dayShortName: date.toLocaleDateString("en-US", { weekday: "short" }),
      dayFullName: date.toLocaleDateString("en-US", { weekday: "long" }),
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate(),
      monthShortName: date.toLocaleDateString("en-US", { month: "short" }),
      monthFullName: date.toLocaleDateString("en-US", { month: "long" }),
      fullDate: fullDate,
      prefix: prefix,
    });
  }

  return slots;
};

const handleDateSelection = (date) => {
  selectedDate.value = date;

  const tempPayload = $payload;
  tempPayload.date = date;
  tempPayload.step = $payload.step + 1;
  $chatWidget.updatePayload(tempPayload);
};

const triggerCalendar = () => {
  showCal.value = true;

  setTimeout(() => {
    const calendar = document.getElementById("prebook-chat-component-calendar");
    calendar.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest",
    });
  }, 500);
};
</script>

<template>
  <div id="prebook-chat-component-date" class="px-4 py-[15px]">
    <div class="inline-flex w-[50px]">
      <img
        :src="$globalSetting?.settings?.business?.full_logo_url"
        :alt="$globalSetting?.settings?.business?.name"
        class="w-full object-contain"
      />
    </div>
    <h2 class="text-[20px]">
      {{ $setting.date.question }}
    </h2>
    <div class="flex flex-wrap gap-2 py-[10px]">
      <Button
        v-for="slot in generateDateSlots()"
        :key="slot.id"
        @click="handleDateSelection(slot.fullDate)"
        size="sm"
        type="secondary_gray"
        buttonStyle="padding: 10px 24px !important;"
      >
        <span class="font-normal text-[16px]">{{
          slot.prefix + " " + slot.monthShortName + " " + slot.day
        }}</span>
      </Button>
      <Button
        @click="triggerCalendar"
        size="sm"
        type="secondary_gray"
        buttonStyle="padding: 10px 24px !important;"
      >
        <span class="font-normal text-[16px]">Choose another day</span>
      </Button>
    </div>
    <div v-if="showCal" id="prebook-chat-component-calendar" class="py-[10px]">
      <Calendar
        :availableDates="$availableDates"
        @date-selected="handleDateSelection"
      />
    </div>
  </div>
  <Transition
    enter-active-class="transition duration-300 ease-out"
    enter-from-class="transform -translate-y-4 opacity-0"
    enter-to-class="transform translate-y-0 opacity-100"
    leave-active-class="transition duration-200 ease-in"
    leave-from-class="transform translate-y-0 opacity-100"
    leave-to-class="transform -translate-y-4 opacity-0"
  >
    <div v-if="$payload?.date" class="p-5 text-right">
      <p class="inline-block bg-gray-200 rounded-[8px] p-4 font-medium m-0">
        <span class="block text-[16px]">{{
          $payload?.date.toLocaleDateString("en-US", { month: "long" }) +
          " " +
          $payload?.date.getDate() +
          ", " +
          $payload?.date.getFullYear()
        }}</span>
      </p>
    </div>
  </Transition>
</template>
